import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { EditOrganisationDto, Organisation, OrganisationDTO, OrganisationDetails, OrganisationPermissionsLabelDto, OrganisationValidationDTO, UpdateOrganisationTableDto } from "src/app/_models/Organisation";
import { OrganisationRecord } from "src/app/_models/OrganisationRecord";
import { OrganisationActionTypes } from "src/app/constants/StoreConstants";

export const GetOrganisationList = createAction(
  OrganisationActionTypes.GetOrganisationList
);

export const GetOrganisationListSuccess = createAction(
  OrganisationActionTypes.GetOrganisationListSuccess,
  props<{ list: Organisation[] }>()
);

export const GetOrganisationListError = createAction(
  OrganisationActionTypes.GetOrganisationListError,
  props<{ error: any }>()
);

export const UpdateOrganisationTable = createAction(
  OrganisationActionTypes.UpdateOrganisationTable,
  props<{
    updateOrganisationTableDto: UpdateOrganisationTableDto;
    isGetLength: boolean;
  }>()
);

export const UpdateOrganisationTableSuccess = createAction(
  OrganisationActionTypes.UpdateOrganisationTableSuccess,
  props<{ result: boolean }>()
);

export const UpdateOrganisationTableError = createAction(
  OrganisationActionTypes.UpdateOrganisationTableError,
  props<{ error: any }>()
);

export const GetOrganisationTable = createAction(
  OrganisationActionTypes.GetOrganisationTable,
  props<{ pageIndex: number; isInitialLoad: boolean; isGetLength: boolean }>()
);

export const GetOrganisationTableSuccess = createAction(
  OrganisationActionTypes.GetOrganisationTableSuccess,
  props<{ result: OrganisationRecord[]; isGetLength: boolean }>()
);

export const GetOrganisationTableError = createAction(
  OrganisationActionTypes.GetOrganisationTableError,
  props<{ error: any }>()
);

export const GetOrganisationTableLength = createAction(
  OrganisationActionTypes.GetOrganisationTableLength
);

export const GetOrganisationTableLengthSuccess = createAction(
  OrganisationActionTypes.GetOrganisationTableLengthSuccess,
  props<{ result: number }>()
);

export const GetOrganisationTableLengthError = createAction(
  OrganisationActionTypes.GetOrganisationTableLengthError,
  props<{ error: any }>()
);

export const ResetOrganisationTable = createAction(
  OrganisationActionTypes.ResetOrganisationTable,
  props<{ isInitialLoad: boolean }>()
);

export const ResetOrganisationTableSuccess = createAction(
  OrganisationActionTypes.ResetOrganisationTableSuccess,
  props<{ isInitialLoad: boolean }>()
);

export const ResetOrganisationTableError = createAction(
  OrganisationActionTypes.ResetOrganisationTableError,
  props<{ error: any }>()
);

export const ResetOrganisationTableUnload = createAction(
  OrganisationActionTypes.ResetOrganisationTable
);

export const CreateOrganisation = createAction(
  OrganisationActionTypes.CreateOrganisation,
  props<{ organisationDto: OrganisationDTO }>()
);

export const CreateOrganisationSuccess = createAction(
  OrganisationActionTypes.CreateOrganisationSuccess,
  props<{ result: Organisation }>()
);

export const CreateOrganisationError = createAction(
  OrganisationActionTypes.CreateOrganisationError,
  props<{ error: any }>()
);

export const IsAvailableOrgName = createAction(
  OrganisationActionTypes.IsAvailableOrgName,
  props<{ orgValidationDto: OrganisationValidationDTO }>()
);

export const IsAvailableOrgNameSuccess = createAction(
  OrganisationActionTypes.IsAvailableOrgNameSuccess
);

export const IsAvailableOrgNameError = createAction(
  OrganisationActionTypes.IsAvailableOrgNameError,
  props<{ error: any }>()
);

export const IsAvailableOrgNameInvalid = createAction(
  OrganisationActionTypes.IsAvailableOrgNameInvalid
);

export const ClearCrudOrganisationState = createAction(
  OrganisationActionTypes.ClearCrudOrganisationState
);

export const ClearAvailability = createAction(
  OrganisationActionTypes.ClearAvailability
);

export const GetOrganisationDetails = createAction(
  OrganisationActionTypes.GetOrganisationDetails,
  props<{ organisationId: number }>()
);

export const GetOrganisationDetailsSuccess = createAction(
  OrganisationActionTypes.GetOrganisationDetailsSuccess,
  props<{ result: OrganisationDetails }>()
);

export const GetOrganisationDetailsError = createAction(
  OrganisationActionTypes.GetOrganisationDetailsError,
  props<{ error: any }>()
);

export const SetOrganisationDetails = createAction(
  OrganisationActionTypes.SetOrganisationDetails
);

export const ClearEditOrganisationState = createAction(
  OrganisationActionTypes.ClearEditOrganisationState
);

export const EditOrganisation = createAction(
  OrganisationActionTypes.EditOrganisation,
  props<{ editOrganisationDto: EditOrganisationDto }>()
);

export const EditOrganisationSuccess = createAction(
  OrganisationActionTypes.EditOrganisationSuccess,
  props<{ result: Organisation }>()
);

export const EditOrganisationError = createAction(
  OrganisationActionTypes.EditOrganisationError,
  props<{ error: any }>()
);

export const RemoveItemsFromOrganisationList = createAction(
  OrganisationActionTypes.RemoveItemsFromOrganisationList,
  props<{ orgIds: number[] }>()
);

export const GetOrganisationPermissions = createAction(
  OrganisationActionTypes.GetOrganisationPermission
);

export const GetOrganisationPermissionsSuccess = createAction(
  OrganisationActionTypes.GetOrganisationPermissionSuccess,
  props<{ list: OrganisationPermissionsLabelDto[] }>()
);

export const GetOrganisationPermissionsError = createAction(
  OrganisationActionTypes.GetOrganisationPermissionError,
  props<{ error: any }>()
);

export const GetIsOrganisationDeletable = createAction(
  OrganisationActionTypes.GetIsOrganisationDeletable,
  props<{orgId: number}>()
);

export const GetIsOrganisationDeletableSuccess = createAction(
  OrganisationActionTypes.GetIsOrganisationDeletableSuccess,
  props<{result: boolean}>()
);

export const GetIsOrganisationDeletableError = createAction(
  OrganisationActionTypes.GetIsOrganisationDeletableError,
  props<{error: HttpErrorResponse}>()
);

export const DeleteOrganisation = createAction(
  OrganisationActionTypes.DeleteOrganisation,
  props<{orgId: number}>()
);

export const DeleteOrganisationSuccess = createAction(
  OrganisationActionTypes.DeleteOrganisationSuccess,
  props<{result: boolean}>()
);

export const DeleteOrganisationError = createAction(
  OrganisationActionTypes.DeleteOrganisationError,
  props<{error: HttpErrorResponse}>()
);

export const ResetOrganisationState = createAction(
  OrganisationActionTypes.ResetOrganisationState
);